import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../../models/RequirementsModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { Editor, MyReactSelect, MyReactSelectMultiple, MySelect, Text, TextArea, TextFloat, TextNumber } from '../../inputs/inputs';
import { getData as getClients } from '../../../models/ClientsModel';
import { getData as getContacts } from '../../../models/ContactsModel';
import { getData as getSkills } from '../../../models/SkillsModel';
import { getData as getModeOfWorks } from '../../../models/ModeOfWorksModel';
import { getManagers, getRecruiters } from '../../../models/UserModel';
import { getRequirementStatus } from '../../../models/MasterModel';
import AdminLayout from '../../layout/AdminLayout';
import { Helmet } from 'react-helmet';
import PageHeader from '../../common/PageHeader';
import { formatDataBeforeDisplay, formatDataBeforeSend, quickAddClient, quickAddContact, quickAddRecruiter, quickAddSkill, quickAddManager, validorSettings } from '../../../helpers/GeneralHelper';
import SimpleReactValidator from 'simple-react-validator';
import { QuickAdd } from '../../modals/QuickAdd';
import { checkPermission } from "../../../helpers/GeneralHelper";
import WorkflowHelpBanner from "../../common/WorkflowHelpBanner";
import RequirementPipeline from "./RequirementPipeline";
import RequirementEligibleCandidates from "./RequirementEligibleCandidates";

export const RequirementForm = () => {

  const location = useLocation();
  const isEdit = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'edit';
  const isView = location.pathname.slice(location.pathname.lastIndexOf("/") + 1, location.pathname.length) == 'view';

  const module = location.state?.module;
  const { unique_id: routeUniqueId } = useParams();
  const [requirementRecord, setRequirementRecord] = useState(location.state?.data ?? null);
  const data = requirementRecord;
  const baseURL = process.env.REACT_APP_BASE_URL;
  const pendingRecruiterIdsRef = useRef("");

  const refEditor = useRef(null);
  const [requirementManagers, setRequirementManagers] = useState('');
  const [requirementRecruiters, setRequirementRecruiters] = useState('');
  const [activePageTab, setActivePageTab] = useState(
    location.state?.openPipelineTab ? 'pipeline' : 'details'
  );
  const showPipelineTab = Boolean(data && (isView || isEdit));

  useEffect(() => {
    if (location.state?.openPipelineTab) {
      setActivePageTab('pipeline');
    }
  }, [location.state?.openPipelineTab, data?._requirement_id]);

  const inputFields = {
    requirement_name: '',
    requirement_client_id: '',
    requirement_contact_id: '',
    requirement_manager_id: requirementManagers,
    requirement_recruiter_id: requirementRecruiters,
    requirement_no_of_positions: '',
    requirement_positions_hold: '',
    requirement_positions_closed: '',
    requirement_location: '',
    requirement_experience_total: '',
    requirement_experience_relevant: '',
    requirement_skills: [],
    requirement_skills_secondary: [],
    requirement_contract_duration: '',
    requirement_bill_rate: '',
    requirement_pay_rate: '',
    requirement_job_description: '',
    requirement_shift_timing: '',
    requirement_mode_of_work_id: '',
    requirement_mode_of_interview: '',
    requirement_remarks: '',
    requirement_status_id: '',
    requirement_type: '',
  }
  const formatOptions = [
    {
      type: 'react-select',
      column: 'requirement_client_id',
      labelColumn: 'client_name'
    },
    {
      type: 'react-select',
      column: 'requirement_contact_id',
      labelColumn: 'contact_name'
    },
    // {
    //   type: 'react-select',
    //   column: 'requirement_manager_id',
    //   labelColumn: 'manager_name'
    // },
    // {
    //   type: 'react-select',
    //   column: 'requirement_recruiter_id',
    //   labelColumn: 'recruiter_name'
    // },
    {
      type: 'react-select-multiple',
      column: 'requirement_skills',
    },
    {
      type: 'react-select-multiple',
      column: 'requirement_skills_secondary',
    },
  ];

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate(); 

  const { state } = useAuth();
  let user_data = state.user_data;

  useEffect(() => {
    if ((!isView && !isEdit) || !routeUniqueId || !user_data?.user_token) {
      return;
    }

    let cancelled = false;

    const loadRequirement = async () => {
      try {
        const row = await model.getView(user_data.user_token, routeUniqueId);
        if (!cancelled && row) {
          setRequirementRecord(row);
        }
      } catch (error) {
        console.error(error);
      }
    };

    loadRequirement();

    return () => {
      cancelled = true;
    };
  }, [routeUniqueId, isView, isEdit, user_data?.user_token]);

  useEffect(() => {
    pendingRecruiterIdsRef.current = data?.recruiter_ids || "";
  }, [data?.recruiter_ids]);
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [id, setId] = useState('');
  const [fields, setFields] = useState(inputFields);

  const [quickModals, setQuickModals] = useState({
    clients: false,
    contacts: false,
    managers: false,
    primary_skills: false,
    secondary_skills: false
  });

  const optionsModeOfInterview = [
    {value: 'F2F', label: 'F2F' },
    {value: 'Virtual', label: 'Virtual' },
  ];
  const optionsRequirementType = [
    {value: 'fte', label: 'Full Time Hiring' },
    {value: 'c2h', label: 'Contract to Hire' },
  ];

  const [clients, setClients] = useState([]);
  const [managers, setManagers] = useState([]);
  const [recruiters, setRecruiters] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [reqStatus, setReqStatus] = useState([]);
  const [skills, setSkills] = useState([]);
  const [modeOfWorks, setModeOfWorks] = useState([]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const result = await getClients({user_token: user_data.user_token, page: 1, limit: -1});
        if (! result) return;

        const clientOptions = result.clients.map(client => ({
          value: client._client_id,
          // label: client.client_name
          label: `${client.client_name} (${client.client_gstin || 'No GSTIN'})`
        }));

        setClients(clientOptions);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchManagers = async() => {
      try {
        let apiParam = {user_token: user_data.user_token};
        const response = await getManagers(apiParam);

        if (typeof response != typeof undefined) {
          const options = response.managers.map(ele => ({
            value: ele._user_id,
            label: ele.user_first_name + ' ' + ele.user_last_name
          }));

          setManagers(options);
        }
      } catch (error) {
          console.error(error);
      }
    }

    const fetchStatus = async() => {
      try {
        let apiParam = {user_token: user_data.user_token};
        const response = await getRequirementStatus(apiParam);

        if (typeof response != typeof undefined) {
          const options = response.requirements_master.map(ele => ({
            value: ele._status_id,
            label: ele.status_name
          }));

          setReqStatus(options);
        }
      } catch (error) {
          console.error(error);
      }
    }

    const fetchSkills = async() => {
      try {
        let apiParam = {user_token: user_data.user_token, page: 1, limit: -1};
        const response = await getSkills(apiParam);

        if (typeof response != typeof undefined) {
          const options = response.skills.map(ele => ({
            value: ele._skill_id,
            label: ele.skill_name
          }));

          setSkills(options);
        }
      } catch (error) {
        console.error(error);
      }
    }

    const fetchModeOfWorks = async() => {
      try {
        let apiParam = {user_token: user_data.user_token, page: 1, limit: -1};
        const response = await getModeOfWorks(apiParam);

        if (typeof response != typeof undefined) {
          const options = response.mode_of_works.map(ele => ({
            value: ele._mode_of_work_id,
            label: ele.mode_of_work_name
          }));

          setModeOfWorks(options);
        }
      } catch (error) {
        console.error(error);
      }
    }

    fetchClients();
    fetchManagers();
    fetchStatus();
    fetchSkills();
    fetchModeOfWorks();
  }, []);

  const [loadingContacts, setLoadingContacts] = useState(false);
  useEffect(() => {
    const fetchContacts = async() => {
      if (! fields.requirement_client_id) {
        fields.requirement_contact_id = '';
        setContacts([]);
        return;
      }

      setLoadingContacts(true);

      try {
        let apiParam = {user_token: user_data.user_token, 'contact_client_id': fields.requirement_client_id.value, page: 1, limit: -1};
        const response = await getContacts(apiParam);

        if (typeof response != typeof undefined) {

          let options = [];
          let flag = false;
          response.client_contacts.forEach(function(item) {
            if (fields.requirement_contact_id == item._contact_id || fields.requirement_contact_id?.value == item._contact_id) {
              flag = true;
            }
            options.push({
              value: item._contact_id,
              label: item.contact_name
            });
          });

          if (! flag) {
            fields.requirement_contact_id = '';
          }

          setContacts(options);
        }
      } catch (error) {
        console.error(error);
      }

      setLoadingContacts(false);
    }

    fetchContacts();
  }, [fields.requirement_client_id]);

  const [loadingRecruiters, setLoadingRecruiters] = useState(false);
  const fetchRecruiters = async() => {
    if (! fields.requirement_manager_id) {
      setFields((prev) => ({ ...prev, requirement_recruiter_id: "" }));
      setRecruiters([]);
      return;
    }

    setLoadingRecruiters(true);

    // Map to extract `value` fields and join them with commas
    const reqUsers = Array.isArray(fields.requirement_manager_id) ? fields.requirement_manager_id.map((item) => item.value).join('-') : '';
    const requirementUsers = Array.isArray(fields.requirement_manager_id) ? fields.requirement_manager_id.map((item) => item.value).join(',') : '';
    //console.log('requirementUsers =>',reqUsers);
    setRequirementManagers(requirementUsers);
    //console.log('requirementRecruiters => ', requirementRecruiters);
    //console.log('requirementManagers => ', requirementManagers);
    try {
      let apiParam = {user_token: user_data.user_token, 'user_manager_id': reqUsers, page: 1, limit: -1};
      const response = await getRecruiters(apiParam);

      if (typeof response != typeof undefined) {

        let options = [];
        let flag = false;
        response.recruiters.forEach(function(item) {
          if (fields.requirement_recruiter_id == item._user_id || fields.requirement_recruiter_id?.value == item._user_id) {
            flag = true;
          }
          options.push({
            value: item._user_id,
            label: item.user_first_name + ' ' + item.user_last_name
          });
        });

        const savedIds = (pendingRecruiterIdsRef.current || "")
          .split(",")
          .map((id) => id.trim())
          .filter(Boolean);

        if (!flag && savedIds.length === 0) {
          setFields((prev) => ({ ...prev, requirement_recruiter_id: "" }));
        }
        options.unshift({ value: -1, label: 'All' });

        setRecruiters(options);
      }
    } catch (error) {
      console.error(error);
    }

    setLoadingRecruiters(false);
  }
  // Watch requirementManagers
useEffect(() => {
  console.log("Updated requirementManagers =>", requirementManagers);
}, [requirementManagers]);

// Watch requirementRecruiters
useEffect(() => {
  console.log("Updated requirementRecruiters =>", requirementRecruiters);
}, [requirementRecruiters]);
  useEffect(() => {

    fetchRecruiters();
  }, [fields.requirement_manager_id]);

  useEffect(() => {
    const getUserRecruiters = async() => {
      
      const selected = fields.requirement_recruiter_id;

      if (!selected) return;

      // If 'All' is selected, keep only that
      if (Array.isArray(selected)) {
        const hasAll = selected.some((opt) => opt.value === -1);
        if (hasAll && selected.length > 1) {
          const onlyAll = selected.filter((opt) => opt.value === -1);
          setFields((prev) => ({ ...prev, requirement_recruiter_id: onlyAll }));
          setRequirementRecruiters('-1');
        }else{
          const selectedValues = selected.map((opt) => opt.value).join(',');
          setRequirementRecruiters(selectedValues);
        }
        console.log('requirementRecruiters =>', requirementRecruiters);
      }
    };
    getUserRecruiters();
  }, [fields.requirement_recruiter_id]);

  useEffect(() => {
    if (data) {
      console.log('data =>', data);
      setId(data[module.primaryCol]);
      const temp = formatDataBeforeDisplay(data, formatOptions);

      // Remove managers/recruiters from temp because we handle them separately
      delete temp.requirement_manager_id;
      delete temp.requirement_recruiter_id;

      setFields((prev) => ({
        ...prev,
        ...temp,
      }));
      setErrors({});
    }
    
    const fetchSelectedSkills = async() => {
      if (! data?._requirement_id) {
        return;
      }

      try {
        const response = await model.getSelectedSkills(user_data.user_token, data._requirement_id);

        if (typeof response != typeof undefined) {
          let pSkills = [];
          let sSkills = [];
          response.data.skills.forEach(function(item) {
            if (item.type == 'main') {
              pSkills.push({ value: item._skill_id, label: item.skill_name });
            } else {
              sSkills.push({ value: item._skill_id, label: item.skill_name });
            }
          });

          setFields((prev) => ({
            ...prev,
            requirement_skills: pSkills,
            requirement_skills_secondary: sSkills,
          }));
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchSelectedSkills();
  }, [data]);

  // STEP 1: Preselect managers once managers are loaded
useEffect(() => {
  if (!data || managers.length === 0) return;

  const temp = formatDataBeforeDisplay(data, formatOptions);

  const man_ids = (data?.manager_ids || temp?.manager_ids || "")
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean);
  let matches_managers;
  if (man_ids?.includes("-1")) {
    matches_managers = [{ value: -1, label: "All" }];
  } else {
    matches_managers = managers.filter((m) => man_ids?.includes(String(m.value)));
  }

  // set preselected managers
  setFields((prev) => ({
    ...prev,
    requirement_manager_id: matches_managers
  }));

}, [data, managers]);

// STEP 2: Fetch recruiters once managers are set
useEffect(() => {
  if (!fields.requirement_manager_id || fields.requirement_manager_id.length === 0) return;

  fetchRecruiters(); // <-- your async function
}, [fields.requirement_manager_id]);

// STEP 3: Preselect recruiters once recruiters are loaded
useEffect(() => {
  if (!data || recruiters.length === 0) return;

  const rec_ids = (data?.recruiter_ids || "")
    .split(",")
    .map((id) => id.trim())
    .filter(Boolean);
  const rec_names = (data?.recruiter_names || "")
    .split(",")
    .map((name) => name.trim())
    .filter(Boolean);

  let matches_recruiters = [];
  if (rec_ids.includes("-1")) {
    matches_recruiters = [{ value: -1, label: "All" }];
  } else if (rec_ids.length > 0) {
    const recruiterPool = [...recruiters];
    rec_ids.forEach((id, index) => {
      if (recruiterPool.some((row) => String(row.value) === String(id))) {
        return;
      }
      recruiterPool.push({
        value: Number(id),
        label: rec_names[index] || `Recruiter #${id}`,
      });
    });
    matches_recruiters = recruiterPool.filter((row) =>
      rec_ids.includes(String(row.value))
    );
  }

  if (matches_recruiters.length > 0) {
    setFields((prev) => ({
      ...prev,
      requirement_recruiter_id: matches_recruiters,
    }));
  }

}, [data, recruiters]);


  const validator = useRef(new SimpleReactValidator({autoForceUpdate: this}));
  const submit = async(e) => {
    e.preventDefault();

    // Validation: Hold + Closed <= Total Positions
    const total = parseInt(fields.requirement_no_of_positions || 0, 10);
    const hold = parseInt(fields.requirement_positions_hold || 0, 10);
    const closed = parseInt(fields.requirement_positions_closed || 0, 10);

    if (hold + closed > total) {
      toast.error("Hold + Closed positions cannot be greater than Total Positions");
      return;
    }

    if (! validator.current.allValid()) {
      toast.error('Please check the form errors!');
      return;
    }
    validator.current.hideMessages();
    
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
      let response;
      if (data) {
        response = await model.update(user_data.user_token, id, formData);
      } else {
        response = await model.create(user_data.user_token, formData);
      }

      if (response.status) {
        setNotificationCount(localStorage.getItem('unread_notification_count'));
        toast.success(response.message);
        model.saveToStorage(response.data[module.key], response.data.pagination);

        if (isEdit) {
          navigate('/' + module.route);
        } else {
          const created = response.data?.created_requirement;
          const createdRow = Array.isArray(created) ? created[0] : created;

          if (createdRow?.requirement_unique_id) {
            navigate(`/requirements/${createdRow.requirement_unique_id}/view`, {
              replace: true,
              state: {
                module,
                data: createdRow,
                openPipelineTab: true,
                pipelineTab: 'suggested',
                showEligible: true,
              },
            });
          } else {
            navigate('/' + module.route);
          }
        }
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);

      if (error.response?.data?.invalid_token == 1) {
        navigate('/re-login');
      }
    }

    setLoading(false);
  }

  if (! module) {
    navigate('/requirements');
    return;
  }

  const goAddCandidate = () => {
    if (!data) return;
    navigate("/candidates/create", {
      state: {
        module: {
          title: "Candidates",
          singularTitle: "Candidate",
          key: "candidates",
          route: "candidates",
          primaryCol: "_candidate_id",
        },
        prefill: {
          clientId: data.requirement_client_id,
          clientName: data.client_name,
          requirementId: data._requirement_id,
          requirementName: data.requirement_name,
        },
      },
    });
  };

  return (
    <AdminLayout>
      <Helmet>
        <title>{isView ? 'View' : isEdit ? 'Edit' : 'Add'} {module.singularTitle} - Digital CMS</title>
      </Helmet>

      <div className="main-content app-content">
        <div className="container-fluid cms-form-shell">
          <PageHeader module={module} />

          {!isView && <WorkflowHelpBanner stage="requirements" />}

          <form onSubmit={submit}>
            {showPipelineTab && (
              <div className="meeting-tabs requirement-page-tabs requirement-page-tabs-top mb-3">
                <button
                  type="button"
                  className={`meeting-tab-btn${activePageTab === "details" ? " active" : ""}`}
                  onClick={() => setActivePageTab("details")}
                >
                  <i className="bi bi-card-text" />
                  Details
                </button>
                <button
                  type="button"
                  className={`meeting-tab-btn${activePageTab === "pipeline" ? " active" : ""}`}
                  onClick={() => setActivePageTab("pipeline")}
                >
                  <i className="bi bi-diagram-3" />
                  Pipeline
                </button>
              </div>
            )}

            {showPipelineTab && activePageTab === "pipeline" ? (
              <div className="row">
                <div className="col-12">
                  <div className="card custom-card">
                    <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                      <div className="card-title">Pipeline</div>
                      <Link className="btn btn-light btn-sm" to="/requirements">
                        <i className="bi bi-reply me-1 fw-semibold" />
                        Back
                      </Link>
                    </div>
                    <div className="card-body">
                      <RequirementPipeline
                        requirement={data}
                        onAddCandidate={goAddCandidate}
                        initialTab={location.state?.pipelineTab || 'overview'}
                        highlightEligible={Boolean(location.state?.showEligible)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
            <>
            <div className="row">
              <div className="col-sm-9">
                <div className="card custom-card">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                    <div className="card-title">{ isView ? 'View' : isEdit ? 'Edit' : 'Add'} {module.singularTitle}</div>
                  </div>
                  <div className="card-body">
                    <div className="row gy-2">
                      <div className="col-xl-4 mb-3">
                        <Text column="requirement_name" label="Requirement Name" required={true} fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <MyReactSelect options={clients} column="requirement_client_id" required={true} label="Client" fields={fields} setFields={setFields} errors={errors} quickAddKey="clients" quickAddSet={setQuickModals} disabled={isView} />
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <MyReactSelect options={contacts} column="requirement_contact_id" required={true} label="POC" fields={fields} setFields={setFields} errors={errors} quickAddKey="contacts" quickAddSet={setQuickModals} disabled={isView} />
                      </div>

                      <div className="col-xl-4 mb-3">
                        <MySelect column="requirement_type" label="Requirement Type" options={optionsRequirementType} firstOption="Select Requirement Type" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <MyReactSelectMultiple options={managers} required={true} column="requirement_manager_id" label="Delivery Manager" fields={fields} setFields={setFields} errors={errors} quickAddKey="managers" quickAddSet={setQuickModals} disabled={isView} />
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <MyReactSelectMultiple options={recruiters} required={true} column="requirement_recruiter_id" label="Recruiter" fields={fields} setFields={setFields} errors={errors} quickAddKey="recruiters" quickAddSet={setQuickModals} disabled={isView} />
                        {isView &&
                        (!fields.requirement_recruiter_id ||
                          (Array.isArray(fields.requirement_recruiter_id) &&
                            fields.requirement_recruiter_id.length === 0)) &&
                        data?.recruiter_names ? (
                          <p className="small text-muted mb-0 mt-1">
                            Assigned recruiters: {data.recruiter_names}
                          </p>
                        ) : null}
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <TextNumber column="requirement_no_of_positions" label="No. of Positions" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                  {/* Show only in edit mode */}
                  {isEdit && (
                    <>
                      <div className="col-xl-4 mb-3">
                        <TextNumber column="requirement_positions_hold" label="Positions On Hold" fields={fields} setFields={setFields} errors={errors} disabled={isView}/>
                      </div>

                      <div className="col-xl-4 mb-3">
                        <TextNumber column="requirement_positions_closed" label="Positions Closed" fields={fields} setFields={setFields} errors={errors} disabled={isView}/>
                      </div>
                    </>
                  )}
                      <div className="col-xl-4 mb-3">
                        <Text column="requirement_location" label="Location" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <TextNumber column="requirement_experience_total" label="Years of Experience (Total)" fields={fields} setFields={setFields} errors={errors} validator={validator} rules='max:2' disabled={isView} />
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <TextNumber column="requirement_experience_relevant" label="Years of Experience (Relevant)" fields={fields} setFields={setFields} errors={errors} validator={validator} rules='max:2' disabled={isView} />
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <MyReactSelectMultiple options={skills} column="requirement_skills" label="Top 3 Skills" fields={fields} setFields={setFields} errors={errors} validator={validator} rules='max:3,array' quickAddKey="primary_skills" quickAddSet={setQuickModals} disabled={isView}/>
                        {isView &&
                        (!fields.requirement_skills || fields.requirement_skills.length === 0) &&
                        data?.top_3_skills ? (
                          <p className="small text-muted mb-0 mt-1">
                            Primary skills: {data.top_3_skills}
                          </p>
                        ) : null}
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <MyReactSelectMultiple options={skills} column="requirement_skills_secondary" label="Secondary Skills" fields={fields} setFields={setFields} errors={errors} quickAddKey="secondary_skills" quickAddSet={setQuickModals} disabled={isView} />
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <Text column="requirement_contract_duration" label="Contract Duration" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <TextFloat column="requirement_bill_rate" label="Bill Rate (Monthly)" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>

                      <div className="col-xl-4 mb-3">
                        <TextFloat column="requirement_pay_rate" label="Pay Rate (Monthly)" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>

                      <div className="col-xl-4 mb-3">
                        <Text column="requirement_shift_timing" label="Shift Timing" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>

                      <div className="col-xl-4 mb-3">
                        <MySelect options={modeOfWorks} column="requirement_mode_of_work_id" label="Mode of Work" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                      
                      <div className="col-xl-4 mb-3">
                        <MySelect options={optionsModeOfInterview} column="requirement_mode_of_interview" label="Mode of Interview" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                      </div>
                    </div>

                    <div className="row gy-2 mt-1">
                      <div className="col-sm-12 mb-3">
                        <Editor column="requirement_job_description" label="Job Description" fields={fields} setFields={setFields} errors={errors} height={400} editorRef={refEditor} disabled={isView} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-3">
                <div className="card custom-card">
                  <div className="card-header d-flex align-items-center justify-content-between flex-wrap gap-3">
                    {(isView && checkPermission(module.route, 'edit')) ? 
                    
                      <a className="btn btn-icon btn-sm btn-info"title="Edit"
                        onClick={() => navigate(`/requirements/${data.requirement_unique_id}/edit`,{ 
                          state: {
                            data: data,
                            module: module,
                          },
                        })} // Navigate to the edit page
                      >
                        <i className='bx bxs-edit'></i>
                      </a>
                        :
                    <div>
                      <button className="btn btn-primary btn-md" disabled={loading}>
                        {loading ? <span><span className="spinner-border spinner-border-sm align-middle"></span> Loading...</span> : 'Save'}
                      </button>
                    </div>
                    }
                    <div className="d-flex flex-wrap gap-2">
                      <Link className="btn btn-light btn-sm float-end" to="/requirements">
                        <i className="bi bi-reply me-1 fw-semibold"></i> Back
                      </Link>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="col-sm-12 mb-3">
                      <MySelect options={reqStatus} required={true} column="requirement_status_id" label="Status" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                    </div>

                    <div className="col-sm-12 mb-3">
                      <TextArea column="requirement_remarks" label="Remarks" fields={fields} setFields={setFields} errors={errors} disabled={isView} />
                    </div>
                    {data && checkPermission("candidates", "add") && (
                      <div className="col-sm-12 mb-3">
                        <button type="button" className="btn w-100 btn-primary" onClick={goAddCandidate}>
                          <i className="ri-user-add-line me-1" />
                          Add candidate
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {showPipelineTab && data?._requirement_id ? (
              <div className="row mt-3">
                <div className="col-12">
                  <div className="card custom-card">
                    <div className="card-body">
                      <RequirementEligibleCandidates
                        requirement={data}
                        userToken={user_data?.user_token}
                        onAddCandidate={goAddCandidate}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            </>
            )}
          </form>
          
        </div>
      </div>

      <QuickAdd title="Client" column="requirement_client_id" setFieldOptions={setClients} modalKey="clients" showModal={quickModals.clients} form={quickAddClient} setShowModal={setQuickModals} setFields={setFields} />
      
      <QuickAdd title="POC" column="requirement_contact_id" dependedColumn="requirement_client_id" setFieldOptions={setContacts} modalKey="contacts" showModal={quickModals.contacts} form={quickAddContact} setShowModal={setQuickModals} setFields={setFields} />
      
      <QuickAdd title="Manager" column="requirement_manager_id" setFieldOptions={setManagers} modalKey="managers" showModal={quickModals.managers} form={quickAddManager()} setShowModal={setQuickModals} setFields={setFields} />
      
      <QuickAdd title="Recruiter" column="requirement_recruiter_id" dependedColumn="requirement_manager_id" setFieldOptions={setRecruiters} modalKey="recruiters" showModal={quickModals.recruiters} form={quickAddRecruiter()} setShowModal={setQuickModals} setFields={setFields} />
      
      <QuickAdd title="Skill" column="requirement_skills" setFieldOptions={setSkills} isMultiple={true} modalKey="primary_skills" showModal={quickModals.primary_skills} form={quickAddSkill} setShowModal={setQuickModals} setFields={setFields} />
      
      <QuickAdd title="Skill" column="requirement_skills_secondary" setFieldOptions={setSkills} isMultiple={true} modalKey="secondary_skills" showModal={quickModals.secondary_skills} form={quickAddSkill} setShowModal={setQuickModals} setFields={setFields} />

      <Helmet></Helmet>
    </AdminLayout>
  );
};
